// TODO removal after full transition to attachments servis

export const formatAttachments = (attachmentsToSend) => {
  if (!attachmentsToSend?.length) return {};
  return Object.fromEntries(
    attachmentsToSend
      .filter((file) => file?.action)
      .map((file, idx, self) => {
        if (file.action === "deleteAttachment") {
          const isForUpdate = self.find(
            (f) => f.action === "updateAttachment" && f.id === file?.id
          );
          if (isForUpdate) {
            return [
              [`${isForUpdate.action}_${isForUpdate.id}`],
              isForUpdate.file,
            ];
          } else {
            return [[`${file.action}_${file.id}`], "null"];
          }
        }
        return [[`${file.action}_${file.id}`], file.file];
      })
  );
};
